/** 影棚主控默认地址（suwa3d_equipment_server；HTTPS :443 可省略端口） */
export const DEFAULT_EQUIPMENT_MASTER_BASE_URL = "https://192.168.88.2";

/**
 * 列表封面兜底机位 123（柱12孔3；与主控 openapi.photo.galleryCoverDeviceId 一致）
 * 正常应优先 equipmentList.cover_device_ids（影棚类型 is_adult_cover）
 */
export const DEFAULT_COVER_DEVICE_ID = 123;

/** 主控流程轮询间隔（对齐自检页 800ms，状态栏可略慢） */
export const MASTER_FLOW_POLL_MS = 800;

/**
 * 主控「拍照采集」进行中状态：此期间左侧列表不轮询 /page，
 * 由 collectProgress 增量更新当前卡采集数
 * shoot → collecting；collect_done 及之后视为结束
 */
export const MASTER_COLLECTING_STATUSES = ["shoot", "shoot_done", "collecting"] as const;

/**
 * 是否处于主控拍照采集阶段
 * @param masterStatus - getTakePhotoFlow.master_status
 */
export function isMasterCollecting(masterStatus?: string | null): boolean {
	if (!masterStatus) {
		return false;
	}
	return (MASTER_COLLECTING_STATUSES as readonly string[]).includes(masterStatus);
}
